import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import FairFilterModal from './components/FairFilterModal'

export default function FairFilter({ selectedFair, onChange }) {
  const [active, setActive] = useState(false)
  const [selection, setSelection] = useState(selectedFair)

  useEffect(() => {
    setSelection(selectedFair)
  }, [selectedFair])

  function close() {
    setActive(false)
  }

  function select(fair) {
    setSelection(fair)
    onChange(fair.id)
    close()
  }

  return (
    <>
      <div className="input-group">
        <button
          type="button"
          id="fairTitle"
          className="btn btn-sm input-group-btn text-left text-ellipsis"
          style={{ flex: '1 1 auto', minWidth: 0 }}
          onClick={() => setActive(true)}
          title={selection?.title || 'Todas as feiras'}
        >
          <i className="fas fa-search" />
          &nbsp;{selection?.title || 'Todas as feiras'}
        </button>
      </div>
      <FairFilterModal
        active={active}
        selectedId={selection?.id}
        onClose={close}
        onChange={select}
      />
    </>
  )
}

FairFilter.propTypes = {
  selectedFair: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
}

FairFilter.defaultProps = {
  selectedFair: null,
}
